import { useMediaQuery, useSsr } from "usehooks-ts";
import { checkIfMobile } from "../../helpers/views.js";
import media from "../../styles/common/media.js";
import useDevice from "../useDevice.js";
export const useDown = (key)=>{
    const string = media.down(key).split('@media ')[1];
    const matches = useMediaQuery(string);
    const { isServer  } = useSsr();
    const device = useDevice();
    if (isServer) {
        return checkIfMobile(device);
    }
    return matches;
};
export default useDown;

//# sourceMappingURL=useDown.js.map